module.exports = __webpack_public_path__ + "static/scale-model-of-amera-travel-network-in-midland-texas-d5efd71d53770702a95d40a73e4138df.png";